import { defineStore } from "pinia";

export const useFormDataStore = defineStore({
	id: "formData",
	state: () => {
		return {
			recaptchaSiteKey: "6LfgGU8pAAAAAGkMNUyy9W_EB9FNPH2-pbtCgsHr",
			testMode: true,
			formName: "",
			Membership: {},
			membershipPayload: null,
			ProgramSelection: {},
			ChildInfo: {},
			Waivers: {},
			ParentSummary: {},
			ParentInformation: [
				{
					firstName: null,
					lastName: null,
					phone2: null,
					phone: null,
					relationship: null,
				},
			],
			EmergencyContactInfo: [
				{
					firstName: null,
					lastName: null,
					phone2: null,
					phone: null,
					relationship: null,
				},
			],
			PaymentInformation: {},
			formSubmissionData: {},
			countryOptions: [
				{ name: "Canada", code: "CA" },
				// { name: "United States", code: "US" },
			],
			provinces: [
				"Alberta",
				"British Columbia",
				"Manitoba",
				"New Brunswick",
				"Newfoundland and Labrador",
				"Northwest Territories",
				"Nova Scotia",
				"Nunavut",
				"Ontario",
				"Prince Edward Island",
				"Québec",
				"Saskatchewan",
				"Yukon Territory",
			],
			provinceOptions: [
				{ name: "Alberta", code: "AB" },
				{ name: "British Columbia", code: "BC" },
				{ name: "Manitoba", code: "MB" },
				{ name: "New Brunswick", code: "NB" },
				{ name: "Newfoundland and Labrador", code: "NL" },
				{ name: "Northwest Territories", code: "NT" },
				{ name: "Nova Scotia", code: "NS" },
				{ name: "Nunavut", code: "NU" },
				{ name: "Ontario", code: "ON" },
				{ name: "Prince Edward Island", code: "PE" },
				{ name: "Quebec", code: "QC" },
				{ name: "Saskatchewan", code: "SK" },
				{ name: "Yukon Territory", code: "YT" },
			],
			// mockData: {
			// 	items: [
			// 		{
			// 			id: "care",
			// 			label: "Before and After Care (one week 8:30am-4:30pm)",
			// 			price: 55,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-1",
			// 			label: "Week 1: July 3rd to July 7th (9am-4pm)",
			// 			price: 175,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-2",
			// 			label: "Week 2: July 10th to July 14th (9am-4pm)",
			// 			price: 175,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-3",
			// 			label: "Week 3: July 17th to July 21st (9am-4pm)",
			// 			price: 175,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-4",
			// 			label: "Week 4: July 24th to July 28th (9am-4pm)",
			// 			price: 175,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-5",
			// 			label: "Week 5: July 31st to August 4th (9am-4pm)",
			// 			price: 175,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-6",
			// 			label: "Week 6: August 7th to 11th (9am-4pm)",
			// 			price: 175,
			// 			locations: ["Oshawa", "Brooklin", "North Oshawa"],
			// 		},
			// 		{
			// 			id: "week-7",
			// 			label: "Week 7: August 14th to 18th (9am-4pm)",
			// 			price: 175,
			// 			locations: [
			// 				"Oshawa",
			// 				"Pickering",
			// 				"Whitby",
			// 				"North Oshawa",
			// 				"Brooklin",
			// 			],
			// 		},
			// 		{
			// 			id: "week-8",
			// 			label: "Week 8: August 21st to 25th (9am-4pm)",
			// 			price: 175,
			// 			locations: ["Pickering", "Whitby"],
			// 		},
			// 		{
			// 			id: "week-9",
			// 			label: "Week 9: August 28th to September 1st (9am-4pm)",
			// 			price: 175,
			// 			locations: ["Pickering", "Whitby"],
			// 		},
			// 	],
			// 	locations: {
			// 		Oshawa: "Oshawa",
			// 		Pickering: "Pickering",
			// 		Whitby: "Whitby",
			// 		"North Oshawa": "North Oshawa",
			// 		Brooklin: "Brooklin",
			// 	},
			// },
		};
	},
	actions: {},
});
